import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import type { ReminderConfiguration } from '@/schema'

interface WorkflowConfigState {
  selectedCompanyId: string | null
  searchQuery: string
  addConfigModalOpen: boolean
  editingReminder: ReminderConfiguration | null

  setSelectedCompanyId: (companyId: string | null) => void
  setSearchQuery: (query: string) => void
  openAddConfigModal: () => void
  closeAddConfigModal: () => void
  setEditingReminder: (reminder: ReminderConfiguration | null) => void
  reset: () => void
}

const initialState = {
  selectedCompanyId: null,
  searchQuery: '',
  addConfigModalOpen: false,
  editingReminder: null,
}

const DEVTOOLS_NAME = 'WorkflowConfigStore'

export const useWorkflowConfigStore = create<WorkflowConfigState>()(
  devtools(
    (set) => ({
      ...initialState,

      setSelectedCompanyId: (companyId: string | null) => {
        set({ selectedCompanyId: companyId }, false, 'setSelectedCompanyId')
      },

      setSearchQuery: (query: string) => {
        set({ searchQuery: query }, false, 'setSearchQuery')
      },

      openAddConfigModal: () => {
        set({ addConfigModalOpen: true }, false, 'openAddConfigModal')
      },

      closeAddConfigModal: () => {
        set({ addConfigModalOpen: false }, false, 'closeAddConfigModal')
      },

      setEditingReminder: (reminder: ReminderConfiguration | null) => {
        set({ editingReminder: reminder }, false, 'setEditingReminder')
      },

      reset: () => {
        set(initialState, false, 'reset')
      },
    }),
    { name: DEVTOOLS_NAME }
  )
)
